import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme, loading }) => css`
    align-content: flex-start;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    font-family: ${theme.v2.font.family.primary};
    gap: 16px;
    min-height: calc(100vh - 80px);
    margin: 0 24px 16px 24px;
    padding-bottom: 140px;
    
    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 0;
      padding-bottom: 0;

      ${loading && css`
        gap: 24px;
      `}
    }
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.white.primary};
    width: 100%;
    
    @media (min-width: ${theme.v2.breakpoints.md}) {
      border-radius: 16px;
      padding: 24px;
    }
  `}
`;

export const WrapperSkeleton = styled.div`
  ${({ theme, position }) => css`
    border-radius: 16px;
    display: flex;
    width: 100%;
    
    ${position === 'banner' && css`
      align-items: center;
      background-color: ${theme.v2.colors.white.primary};
      flex-direction: column;
      gap: 16px;
      padding: 48px 24px 29px;

      @media (max-width: ${theme.v2.breakpoints.md}) {
        border-radius: 0;
      }
    `}

    ${position === 'headers' && css`
      flex-direction: row;
      gap: 16px;
    `}

    ${position === 'table' && css`
      flex-direction: column;
      gap: 16px;
      padding-top: 20px;
    `}

    ${position === 'bottom' && css`
      align-items: center;
      flex-direction: column;
      padding-top: 8px;
    `}
  `}
`;

export const ContentSkeleton = styled.div`
  ${({ theme }) => css`
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 0 20px;
    }
  `}
`;

export const ColumnSkeleton = styled.div`
  ${({ theme, type }) => css`
    background: ${theme.v2.colors.white.primary};
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 32px 20px 20px;

    @media (min-width: ${theme.v2.breakpoints.md}) {
      ${type === 'desc' && css`
        width: 40%;
      `}

      ${type === 'plan' && css`
        width: 30%;
      `}
    }
  `}
`;

export const WrapperButtonSkeleton = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 16px;
    margin-top: 82px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: calc(100vw - 80px);
    }
  `}
`;

export const ButtonSkeletonItem = styled.div`
  ${({ theme }) => css`
    display: flex;
  
    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-width: calc(50% - 8px);
    }
  `}
`;

export const LineSkeleton = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.white.primary};
    border-radius: 16px;
    height: 70px;
    width: 100%;
  `}
`;

export const ButtonSkeleton = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.white.primary};
    border-radius: 16px;
    height: 32px;
    width: 164px;
  `}
`;
